import { Button } from "@mui/material";
import instance from "../../services/axios";

const LogoutButton = () => {
  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      window.location.href = "https://login.microsoftonline.com/logout";
      return;
    }

    try {
      const res = await instance.post("auth/logout");

      const { logoutUrl } = await res.data;

      localStorage.removeItem("token");
      window.location.href = logoutUrl;
    } catch (err) {
      console.error("Logout error", err);
      window.location.href = "https://login.microsoftonline.com/logout";
    }
  };

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: "#ffffff",
        color: "#B91C1C",
        borderColor: "#B91C1C",
        textTransform: "none",
        fontWeight: 500,
        "&:hover": {
          backgroundColor: "#FEE2E2",
          borderColor: "#B91C1C",
        },
      }}
      onClick={handleLogout}
    >
      Logout
    </Button>
  );
};

export default LogoutButton;
